import { Formik, Form, useField } from "formik";
import { Form as BootstrapForm } from "react-bootstrap";
import {
  TextInputComp,
  ButtonComp,
  CardComp,
} from "../../../../components";

// Auto Generate Checkbox Component
const AutoGenerateCheckbox = () => {
  const [field, meta, helpers] = useField("auto_generate");
  
  return (
    <div>
      <BootstrapForm.Check
        type="switch"
        id="auto-generate-switch"
        label={<span className="ms-2 fw-2">Auto Generate Numbers</span>}
        checked={field.value || false}
        onChange={(e) => helpers.setValue(e.target.checked)}
        isInvalid={meta.touched && meta.error}
      />
      {meta.touched && meta.error && (
        <div className="text-danger small mt-1">{meta.error}</div>
      )}
    </div>
  );
};

const PrefixForm = ({
  initialValues,
  handleFormSubmit,
  activeBranchName = "Current Branch",
  isSubmitting = false,
}) => {
  // Ensure auto_generate is in initialValues
  const formInitialValues = {
    ...initialValues,
    auto_generate: initialValues.auto_generate ?? false,
  };

  return (
    <div>
      <Formik initialValues={formInitialValues} onSubmit={handleFormSubmit}>
        <Form>
          <CardComp
            cardClassName={"pt-4"}
            cardBodyClassName={"py0-0 row gx-5 gy-3 justify-content-between"}
          >
            <div className="col-12 col-lg-5">
              <div className="mb-3">
                <label className="fw-2 mb-2 d-block">Branch Name</label>
                <div className="px-3 py-2 bg-light rounded border" style={{ borderColor: "#A1A0A0" }}>
                  <span className="text-muted">{activeBranchName}</span>
                  <small className="d-block text-muted mt-1" style={{ fontSize: "12px" }}>
                    Prefix will be set for your active branch only
                  </small>
                </div>
              </div>
              <div className="mb-3">
                <TextInputComp
                  LabelText={"Prefix Name"}
                  borderColor="#A1A0A0"
                  LabelClassName={"fw-2"}
                  placeholder={"Enter Prefix"}
                  name={"name"}
                />
              </div>
            </div>
            <div className="col-12 col-lg-5">
              <div className="mb-3">
                <TextInputComp
                  LabelText={"Membership Numeric Count"}
                  borderColor="#A1A0A0"
                  LabelClassName={"fw-2"}
                  placeholder={"001"}
                  name={"count"}
                  type={"number"}
                />
                <small className="text-muted d-block mt-1" style={{ fontSize: "12px" }}>
                  Number of digits after the prefix (e.g., 4 = "0001", "0002")
                </small>
              </div>
              <div className="mb-3">
                <AutoGenerateCheckbox />
                <small className="text-muted d-block mt-1" style={{ fontSize: "12px" }}>
                  <strong>OFF (Sequential):</strong> unique-0001, unique-0002, unique-0003<br/>
                  <strong>ON (Random):</strong> unique-5785, unique-8564, unique-1234
                </small>
              </div>
            </div>
          </CardComp>
          <div className="">
            <ButtonComp
              btnText={"Submit prefix"}
              type={"submit"}
              disabled={isSubmitting}
              loading={isSubmitting}
              btnClassName={"bg-primary1 py-2 px-4 rounded text-white border-0"}
            />
          </div>
        </Form>
      </Formik>
    </div>
  );
};

export default PrefixForm;
